import { getReports } from "@/api/report";
import { ReportQuery } from "@/models/report.model";
import { useQuery } from "@tanstack/react-query";

import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const useReport = () => {
    const [query, setQuery] = useState<ReportQuery>({
        day: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0],
        page: 1,
        limit: 10,
        uid: ''
    });

    const [search, setSearch] = useSearchParams();

    const handleSetQuery = (newQuery: Partial<ReportQuery>) => {
        setQuery({ ...query, ...newQuery });
    }

    useEffect(() => {
        setSearch({
            day: query.day?.toString() || '',
            page: query.page.toString(),
            limit: query.limit.toString(),
            uid: query.uid || '',
        });
    }, [query.day, query.page, query.limit, query.uid, setSearch]);



    const { data: reports, isLoading, refetch } = useQuery({
        queryKey: ['reports', query],
        queryFn: () => getReports(query),
    });

    return { reports, isLoading, refetch, handleSetQuery, query, search };
};

export default useReport;
